import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ClientViewState {
  active: boolean;
  userId: number | null;
  displayName: string;
  isChatBotAllowed: boolean;
  isIntegrationUser: boolean;
  isDataStorageUser: boolean;
  isCalibrateAdmin: boolean;
  isSuperuser: boolean;
  isInternalUser: boolean;
  isPartnershipTeam: boolean;
  canDownloadTopDocumentFolders: boolean;
  isSecureFileUploadUser: boolean;
}

export interface SetClientViewPayload {
  userId: number;
  displayName: string;
  isChatBotAllowed: boolean;
  isIntegrationUser: boolean;
  isDataStorageUser: boolean;
  isCalibrateAdmin: boolean;
  isSuperuser: boolean;
  isInternalUser: boolean;
  isPartnershipTeam: boolean;
  canDownloadTopDocumentFolders: boolean;
  isSecureFileUploadUser: boolean;
}

const initialState: ClientViewState = {
  active: false,
  userId: null,
  displayName: "",
  isChatBotAllowed: false,
  isIntegrationUser: false,
  isDataStorageUser: false,
  isCalibrateAdmin: false,
  isSuperuser: false,
  isInternalUser: false,
  isPartnershipTeam: false,
  canDownloadTopDocumentFolders: false,
  isSecureFileUploadUser: false,
};

const clientViewSlice = createSlice({
  name: "clientView",
  initialState,
  reducers: {
    setClientView: (state, action: PayloadAction<SetClientViewPayload>) => {
      const {
        userId,
        displayName,
        isChatBotAllowed,
        isIntegrationUser,
        isDataStorageUser,
        isCalibrateAdmin,
        isSuperuser,
        isInternalUser,
        isPartnershipTeam,
        canDownloadTopDocumentFolders,
        isSecureFileUploadUser,
      } =
        action.payload;
      state.active = true;
      state.userId = userId;
      state.displayName = displayName;
      state.isChatBotAllowed = isChatBotAllowed;
      state.isIntegrationUser = isIntegrationUser;
      state.isDataStorageUser = isDataStorageUser;
      state.isCalibrateAdmin = isCalibrateAdmin;
      state.isSuperuser = isSuperuser;
      state.isInternalUser = isInternalUser;
      state.isPartnershipTeam = isPartnershipTeam;
      state.canDownloadTopDocumentFolders = canDownloadTopDocumentFolders;
      state.isSecureFileUploadUser = isSecureFileUploadUser;
    },
    clearClientView: (state) => {
      state.active = false;
      state.userId = null;
      state.displayName = "";
      state.isChatBotAllowed = false;
      state.isIntegrationUser = false;
      state.isDataStorageUser = false;
      state.isCalibrateAdmin = false;
      state.isSuperuser = false;
      state.isInternalUser = false;
      state.isPartnershipTeam = false;
      state.canDownloadTopDocumentFolders = false;
      state.isSecureFileUploadUser = false;
    },
  },
});

export const { setClientView, clearClientView } = clientViewSlice.actions;
export default clientViewSlice.reducer;
